import { createSelector } from 'reselect'
import getUserSelector from 'modules/users/selectors/get-user'

function getCurrentUserSelector () {
  return createSelector(
    state => getUserSelector(state.users.current)(state),
    currentUser => currentUser
  )
}

export default getCurrentUserSelector
